import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`await Posthog().capture(
  eventName: 'user_signed_up',
);
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`await Posthog().capture(
  eventName: 'user_signed_up',
  properties: {
    'login_type': 'email',
    'is_free_trial': true
  }
);
`}</code></pre>
    <h3 {...{
      "id": "autocapture"
    }}>{`Autocapture`}</h3>
    <p>{`PostHog autocapture automatically tracks the following events for you:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Application Opened`}</strong>{` - when the app is opened from a closed state or when the app comes to the foreground (e.g. from the app switcher)`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Backgrounded`}</strong>{` - when the app is sent to the background by the user`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Installed`}</strong>{` - when the app is installed.`}</li>
      <li parentName="ul"><strong parentName="li">{`Application Updated`}</strong>{` - when the app is updated.`}</li>
      <li parentName="ul"><strong parentName="li">{`$screen`}</strong>{` - when the user navigates (if using `}<a parentName="li" {...{
          "href": "https://docs.flutter.dev/ui/navigation"
        }}>{`navigatorObservers`}</a>{` or `}<a parentName="li" {...{
          "href": "https://pub.dev/packages/go_router"
        }}>{`go_router`}</a>{`)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      